import "../../pages/templates/templates.css";
import "../../styles/fonts.css";

export const FollowCount = ({ count, text }) => {
  const safeCount = Number.isFinite(Number(count)) ? Number(count) : 0;

  return (
    <div
      className="follow-count"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
      }}
    >
      <div style={{ textAlign: "center", width: "100%" }}>
        {safeCount}
      </div>
      <div style={{ textAlign: "center", width: "100%" }} >
        {text}
      </div>
    </div>
  );
};
